<template>
  <div>
    <einapage
      v-on:setPage="setPage"
      v-model="perpage.value"
      :perpage="perpage.options"
      :currentrows="$props.autoUpdate ? perpage.value : $props.currentrows"
      :currentpage="currentpage"
      :rowcount="$props.rowcount"
      :pagecount="$props.pagecount"
      :overlayclass="
        `einapage-instance-container ${!!$props.overlayclass ? $props.overlayclass : ''}`
      "
      :selectclass="
        `einapage-instance-container-select ${!!$props.selectclass ? $props.selectclass : ''}`
      "
      :detailsclass="`${!!$props.detailsclass ? $props.detailsclass : ''}`"
      :itemclass="`${!!$props.itemclass ? $props.itemclass : ''}`"
      :dataclass="`${!!$props.dataclass ? $props.dataclass : ''}`"
      :perpageclass="`${!!$props.perpageclass ? $props.perpageclass : ''}`"
    >
      <template v-slot:details="data">
        <slot
          name="details"
          :currentrows="data.currentrows"
          :rowcount="data.rowcount"
          :currentpage="data.currentpage"
          :pagecount="data.pagecount"
        >
          {{ $t("portfolio.einaPage.instance.showing") }}
          {{ data.currentrows }}
          {{ $t("portfolio.einaPage.instance.of") }}
          {{ data.rowcount }}
          {{ $t("portfolio.einaPage.instance.rows") }}
          {{ data.currentpage }}
          {{ $t("portfolio.einaPage.instance.of") }}
          {{ data.pagecount }}.
        </slot>
      </template>
      <template v-slot:perPage="data">
        <slot name="perPage" :perpage="data.perpage" />
      </template>
      <template v-slot:firstArrow>
        <slot name="firstArrow" />
      </template>
      <template v-slot:lastArrow>
        <slot name="lastArrow" />
      </template>
    </einapage>
  </div>
</template>

<script>
const Einapage = () => import(/* webpackChunkName: "EinapageComponent" */ "einapage-vue");

export default {
  name: "EinapageInstance",
  components: {
    Einapage
  },
  props: {
    /*
     * @property - autoUpdate
     * Defines if component instance should be updated during user plays with it
     */
    autoUpdate: {
      type: Boolean,
      default: true
    },
    /*
     * @property - currentrows
     * Defines number of rows in current page to pass to instance
     */
    currentrows: {
      type: Number,
      default: 17
    },
    /*
     * @property - rowcount
     * Defines total rows to pass to instance
     */
    rowcount: {
      type: Number,
      default: 25100
    },
    /*
     * @property - pagecount
     * Defines total pages to pass to instance
     */
    pagecount: {
      type: Number,
      default: 1255
    },
    /*
     * @property - perpageclass
     * Defines perpageclass to pass to instance
     */
    perpageclass: {
      type: String,
      default: null
    },
    /*
     * @property - selectclass
     * Defines selectclass to pass to instance
     */
    selectclass: {
      type: String,
      default: null
    },
    /*
     * @property - overlayclass
     * Defines overlayclass to pass to instance
     */
    overlayclass: {
      type: String,
      default: null
    },
    /*
     * @property - detailsclass
     * Defines detailsclass to pass to instance
     */
    detailsclass: {
      type: String,
      default: null
    },
    /*
     * @property - itemclass
     * Defines itemclass to pass to instance
     */
    itemclass: {
      type: String,
      default: null
    },
    /*
     * @property - dataclass
     * Defines dataclass to pass to instance
     */
    dataclass: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      currentpage: 4,
      perpage: {
        value: null,
        options: [5, 10, 15, 20, 25]
      }
    };
  },
  methods: {
    /*
     * @function - setPage
     * This function initialize scene, camera, and renderer for xterminate instance
     * @param - p (Number): Defines page to move instance if autoUpdate property is true
     */
    setPage(p) {
      if (this.$props.autoUpdate) {
        this.currentpage = p;
      }
    }
  },
  mounted() {
    if (this.$props.autoUpdate) {
      this.perpage.value = 10;
    }
  }
};
</script>

<style src="einapage-vue/app/css/einapage.css" />
<style lang="scss" scoped>
::v-deep .einapage-instance-container {
  &-highlighted {
    border: 0.075rem solid $white-purple;
    border-radius: 0.75rem;
    color: $white-purple;
    padding: 0 0.5rem;
  }

  &.custom-overlay {
    border: 0.125rem dashed $white-purple;
    border-radius: 0.75rem;
    padding: 1.5rem 1rem;
  }

  .custom-perpage {
    border: 0.125rem dashed $white-purple;
    border-radius: 0.75rem;
    padding: 0 0.5rem;
  }

  .custom-select {
    background-color: $live-blue;
  }

  .custom-details {
    border: 0.125rem dashed $white-purple;
    border-radius: 0.75rem;
    padding: 0 0.5rem;
  }

  .custom-item {
    &:not(.active) a {
      background-color: $live-blue;
      border-color: $white-purple;
      color: $white-purple;
    }
    &.active a {
      background-color: $white-purple;
      border-color: $live-blue;
      color: $live-blue;
    }
  }

  .custom-data {
    color: $white-purple;
    font-style: italic;
  }
}
</style>
